import { render, staticRenderFns } from "./ModalProductos.vue?vue&type=template&id=24353e1f&scoped=true"
import script from "./ModalProductos.vue?vue&type=script&lang=js"
export * from "./ModalProductos.vue?vue&type=script&lang=js"
import style0 from "./ModalProductos.vue?vue&type=style&index=0&id=24353e1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24353e1f",
  null
  
)

export default component.exports